import { useState } from "react";
import { BottomSection } from "./components/home/BottomSection";
import { DemoSection } from "./components/home/DemoSection";
import { HeroSection } from "./components/home/HeroSection";
import { type BillingCycle, PricingSection } from "./components/home/PricingSection";
import { ProductSections } from "./components/home/ProductSections";
import SiteLayout from "./components/layout/SiteLayout";
import { SLACK_OAUTH_URL, SLACK_OAUTH_URL_TRIAL } from "./config";

function App() {
  const [billingCycle, setBillingCycle] = useState<BillingCycle>("monthly");

  return (
    <SiteLayout navVariant="home" footerVariant="home">
      <main>
        <HeroSection slackOauthUrl={SLACK_OAUTH_URL} />
        <DemoSection />
        <ProductSections />
        <PricingSection
          billingCycle={billingCycle}
          setBillingCycle={setBillingCycle}
          slackOauthUrl={SLACK_OAUTH_URL}
          slackOauthUrlTrial={SLACK_OAUTH_URL_TRIAL}
        />
        <BottomSection slackOauthUrl={SLACK_OAUTH_URL} />
      </main>
    </SiteLayout>
  );
}

export default App;
